import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { Formik, Form } from 'formik';
import DocumentTemplateIcon from 'assets/document-template-icon.svg';

import { ButtonPrimary } from '@yuhu-inc/yuhui';
import env from 'config/constants';

import { getTranslatedString } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';
import { hellosignClient } from 'helpers/hellosignClient';

import { StyledFooterText } from './form_fields/shared_styles/footers';

const StyledForm = styled(Form)`
  width: 100%;
  position: relative;
  ${media.mobile`
  width: 80%;
  `};
`;

const StyledInner = styled.div`
  width: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${media.mobile`
  max-height: 550px;
  `};
`;

const StyledDiv = styled.div`
  display: inherit;
  flex-direction: inherit;
  text-align: center;
  width: 25%;
  align-items: center;
  ${media.mobile`
  width: 100%;
  `};
`;

const StyledIcon = styled.img`
  width: 180px;
  height: 180px;
  margin-bottom: 20px;
`;

const StyledH4 = styled.h4`
  margin-bottom: 20px;
`;

const StyledVerbiage = styled.div`
  margin-bottom: 20px;
`;

const StyledButton = styled(ButtonPrimary)`
  margin-top: 25px;
  width: max-content;
  align-self: center;
`;

export const DocumentTemplateConfigureSignaturesPage = ({
  closeDialog,
  clientId,
  documentTemplate,
  ...rest
}) => {
  const handleSubmit = useCallback(() => {
    hellosignClient.open(documentTemplate.callback_url, {
      clientId,
      skipDomainVerification: env.ENV !== 'production',
    });
  }, [documentTemplate, clientId]);

  useEffect(() => {
    hellosignClient.on('createTemplate', () => {
      closeDialog();
    });
  }, [closeDialog]);

  hellosignClient.on('close', () => {
    closeDialog();
  });

  return (
    <Formik initialValues={{}} onSubmit={handleSubmit}>
      {() => (
        <StyledForm {...rest}>
          <StyledInner>
            <StyledDiv>
              <StyledIcon src={DocumentTemplateIcon} />
              <StyledH4>
                {getTranslatedString(
                  'landlordPortal.documentTemplate.configureSignatures.mapFields'
                )}
              </StyledH4>
              <StyledVerbiage>
                {getTranslatedString(
                  'landlordPortal.documentTemplate.configureSignatures.toCompletePleaseMap'
                )}
              </StyledVerbiage>
              <StyledButton contentKey="landlordPortal.documentTemplate.configureSignatures.buttonVerbiage" />
              <StyledFooterText>
                {getTranslatedString('landlordPortal.documentTemplate.completedPagesAutoSave')}
              </StyledFooterText>
            </StyledDiv>
          </StyledInner>
        </StyledForm>
      )}
    </Formik>
  );
};
